module.exports = __webpack_public_path__ + "static/media/success.d0c0c8f0.svg";